/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppointmentState } from '../../models/appointment-state';

export interface GetAllStates$Params {
}

export function getAllStates(http: HttpClient, rootUrl: string, params?: GetAllStates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppointmentState>>> {
  const rb = new RequestBuilder(rootUrl, getAllStates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppointmentState>>;
    })
  );
}

getAllStates.PATH = '/api/app-states';
